// Copyright (c) 2019 Verimatrix, Inc.  All Rights Reserved.

import {createStore as reduxCreateStore, applyMiddleware, compose} from 'redux'
import {routerMiddleware} from 'connected-react-router'
import thunk from 'redux-thunk'

import history from './history'
import createRootReducer from './reducers'

let composeEnhancers = compose
if (process.env.NODE_ENV === 'development') {
  composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
}

function createStore (initialState = {}) {
  return reduxCreateStore(
    createRootReducer(history), // new root reducer with router state
    initialState,
    composeEnhancers(
      applyMiddleware(
        routerMiddleware(history), // for dispatching history actions
        thunk
      )
    ))
}

const store = createStore()

export {createStore}
export default store
